export default "__VITE_ASSET__DzlHdslv__"